import {
  getLevelArray,
  getSameAttribute,
  removeNull,
  sortArray
} from '@/utils/handleData'

export default {
  namespaced: true,
  state: {
    concealedWorkList: [], // 缓存当前选择机构的隐蔽工程列表
    concealedWorkInfo: [] // 缓存隐蔽工程信息
  },
  actions: {
    // 获取当前选择机构的隐蔽工程列表
    async getConcealedWorkList({ rootState, commit, dispatch }, data) {
      var queryValues = {
        orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue,
        subitemUid:
          data && data.subitemUid
            ? data.subitemUid
            : rootState.queryValues.concealedWork &&
              rootState.queryValues.concealedWork.subitemUid
            ? rootState.queryValues.concealedWork.subitemUid
            : '',
        progressUid:
          data && data.progressUid
            ? data.progressUid
            : rootState.queryValues.concealedWork &&
              rootState.queryValues.concealedWork.progressUid
            ? rootState.queryValues.concealedWork.progressUid
            : ''
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/concealedworks',
          data: queryValues
        },
        { root: true }
      )
      // console.log(res)
      var concealedWorkList = res.data ? res.data : []
      concealedWorkList.forEach((item) => {
        item.workBatchName = item.workBatchName
          ? item.workBatchName
          : item.concealedWork
        item.subitemSN = item.subitemCode + '\xa0\xa0' + item.subitemName
        item.progressItemCT =
          item.progressItemTypeCode + '\xa0\xa0' + item.progressItemType
        item.checkImages = item.checkImages ? item.checkImages : []
        item.checkVideos = item.checkVideos ? item.checkVideos : []
        const progressRate = parseFloat(item.rateOfProgress)
        const finishFlag = parseFloat(item.workFinishFlag)
        item.rateOfProgress = Number.isFinite(progressRate) ? progressRate : 0
        item.isCompleted =
          item.checkVideos.length || item.checkImages.length
            ? '已验收'
            : Number.isFinite(finishFlag) &&
              item.rateOfProgress >= finishFlag
            ? '待验收'
            : '未完成'
        item.checkImagesInfo = item.checkImages.length
          ? item.checkImages.length + '张图片'
          : '无验收图片'
        item.checkVideosInfo = item.checkVideos.length
          ? item.checkVideos.length + '个视频'
          : '无验收视频'
        commit(
          'pictureSet',
          { key: 'checkImages', value: item.checkImages },
          { root: true }
        )
        item.srcList = getSameAttribute(
          rootState.pictures.checkImages,
          'url'
        ).values
        item.fileLists = {
          checkImages: rootState.pictures.checkImages,
          checkVideos: item.checkVideos.length
            ? item.checkVideos.map((video, num) => {
                return {
                  uid: video,
                  videoUid: video,
                  url: require('@/assets/img/video.webp'),
                  name: '验收视频' + (num + 1),
                  type: 'application/x-mpegURL'
                }
              })
            : []
        }
      })
      const isCompleted =
        data && data.isCompleted
          ? data.isCompleted
          : rootState.queryValues.concealedWork &&
            rootState.queryValues.concealedWork.isCompleted
          ? rootState.queryValues.concealedWork.isCompleted
          : ''
      if (isCompleted) {
        concealedWorkList = concealedWorkList.filter((item) => {
          return item.isCompleted === isCompleted
        })
      }
      var params = {
        uid: 'progressUid',
        label: 'subitemSN',
        childUid: 'uid',
        childLabel: 'workBatchName',
        keepKeys: ['progressItemTypeCode', 'progressItemType', 'progressItemCT']
      }
      concealedWorkList = getLevelArray(concealedWorkList, params)
      params = {
        uid: 'progressItemTypeCode',
        label: 'progressItemCT',
        childUid: 'uid',
        childLabel: 'label'
      }
      concealedWorkList = getLevelArray(concealedWorkList, params)
      concealedWorkList = sortArray(concealedWorkList, [
        'label',
        'concealedWork',
        'workFinishFlag'
      ])
      commit(
        'baseSet',
        {
          module: 'concealedWork',
          key: 'concealedWorkList',
          value: concealedWorkList
        },
        { root: true }
      )
    },
    // 添加隐蔽工程
    async addConcealedWork({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/concealedworks',
          data: data,
          msg: '添加隐蔽工程成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑隐蔽工程
    async editConcealedWork({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/concealedworks',
          data: data,
          msg: '编辑隐蔽工程信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除隐蔽工程
    async deleteConcealedWork({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/concealedworks',
          data: { uid: uid },
          msg: '删除隐蔽工程成功'
        },
        { root: true }
      )
      return res
    }
  }
}
